import { useEffect, useState } from 'react';
import './BackToTop.css';

function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setVisible(window.scrollY > 300);
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={`back-to-top-wrapper ${visible ? 'back-to-top-visible' : ''}`}>
            <span className='back-to-top-tooltip'>Torna in cima</span>
            <button
                className='back-to-top'
                onClick={scrollToTop}
                aria-label="Torna in cima"
            >
                ↑
            </button>
        </div>
    );
}

export default BackToTop;
